import styled from 'styled-components';
import { Header } from 'semantic-ui-react';

export const ModalHeader = styled(Header)`
  color: ${p => p.theme.colors['scaleDarkBlue']}!important;
  border-bottom: 0px !important;
  padding-bottom: 0px !important;
`;
